import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Form for rule_type='flat'.
 * rule_value shape: { value: <number> }
 * Example: 10 creators/month.
 */
const FlatRuleForm = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();
  const v = value?.value ?? '';

  return (
    <div className="space-y-2">
      <label className="block text-xs uppercase tracking-widest text-muted-foreground font-semibold">
        {t('admin.objectiveRules.form.flat.value', 'Flat value')}
      </label>
      <input
        type="number"
        step="any"
        disabled={disabled}
        value={v}
        onChange={(e) =>
          onChange({ value: e.target.value === '' ? null : Number(e.target.value) })
        }
        className="w-full px-3 py-2 rounded-lg bg-card border border-border text-foreground text-base tabular-nums outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 disabled:opacity-60"
        placeholder="10"
      />
      <p className="text-xs text-muted-foreground">
        {t(
          'admin.objectiveRules.form.flat.help',
          'Each agent gets exactly this value as their target for the metric.'
        )}
      </p>
    </div>
  );
};

export default FlatRuleForm;
